import React from "react";
import { CircularProgress } from "@mui/joy";
import "../index.css";

interface LoadingProps {
  children?: React.ReactNode;
}

const Loading: React.FC<LoadingProps> = () => {
  return (
    <div className="loading-container">
      <CircularProgress className="loading-icon" />
    </div>
  );
};

export default Loading;
